<app-header [forceLightBackground]="true"></app-header>
<div class="create-organisation-page">
  <div class="create-organisation-page--layout">
    <app-consumer-sidebar #sidebar class="create-organisation-page--sidebar"></app-consumer-sidebar>
    <div class="create-organisation-page--content">
      <app-page-header></app-page-header>
      
      <div class="create-organisation-container">
        <div class="vertical-stepper-layout">
          <!-- Vertical Stepper Navigation -->
          <div class="stepper-nav">
            <div class="stepper-nav-item" [class.active]="activeStep === 0" [class.completed]="activeStep > 0" (click)="activeStep >= 0 && (activeStep = 0)">
              <div class="step-indicator">
                <div class="step-number" *ngIf="activeStep <= 0">1</div>
                <svg *ngIf="activeStep > 0" class="step-check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="20 6 9 17 4 12" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">User Details</div>
                <div class="step-description">Personal information</div>
              </div>
            </div>

            <div class="stepper-nav-item" [class.active]="activeStep === 1" [class.completed]="activeStep > 1" (click)="activeStep >= 1 && (activeStep = 1)">
              <div class="step-indicator">
                <div class="step-number" *ngIf="activeStep <= 1">2</div>
                <svg *ngIf="activeStep > 1" class="step-check" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <polyline points="20 6 9 17 4 12" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="step-content">
                <div class="step-title">Entity Details</div>
                <div class="step-description">Provider information</div>
              </div>
            </div>

            <div class="stepper-nav-item" [class.active]="activeStep === 2" [class.completed]="activeStep > 2" (click)="activeStep >= 2 && (activeStep = 2)">
              <div class="step-indicator">
                <div class="step-number">3</div>
              </div>
              <div class="step-content">
                <div class="step-title">Documents</div>
                <div class="step-description">Upload files</div>
              </div>
            </div>
          </div>

          <!-- Form Content Area -->
          <div class="stepper-content">
            <!-- Step 1: User Details -->
            <div class="step-panel" *ngIf="activeStep === 0">
              <form [formGroup]="userDetailsForm" class="step-form">
                <div class="form-grid">
                  <!-- First Name -->
                  <div class="form-field">
                    <label for="firstName" class="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      formControlName="firstName"
                      class="form-input input-disabled"
                      placeholder="First name"
                    />
                  </div>

                  <!-- Last Name -->
                  <div class="form-field">
                    <label for="lastName" class="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      formControlName="lastName"
                      class="form-input input-disabled"
                      placeholder="Last name"
                    />
                  </div>

                  <!-- Registered Email (Disabled) -->
                  <div class="form-field full-width">
                    <label for="registeredEmail" class="form-label">
                      Registered Email
                    </label>
                    <input
                      type="email"
                      id="registeredEmail"
                      formControlName="registeredEmail"
                      class="form-input input-disabled"
                      placeholder="Email address"
                    />
                  </div>

                  <!-- Job Title -->
                  <div class="form-field">
                    <label for="jobTitle" class="form-label">
                      Job Title <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="jobTitle"
                      formControlName="jobTitle"
                      class="form-input"
                      [class.input-error]="isFieldInvalid(userDetailsForm, 'jobTitle')"
                      placeholder="e.g., Data Manager"
                    />
                    <span class="error-message" *ngIf="isFieldInvalid(userDetailsForm, 'jobTitle')">
                      {{ getErrorMessage(userDetailsForm, 'jobTitle') }}
                    </span>
                  </div>

                  <!-- Employee ID -->
                  <div class="form-field">
                    <label for="employeeId" class="form-label">
                      Employee ID <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="employeeId"
                      formControlName="employeeId"
                      class="form-input"
                      [class.input-error]="isFieldInvalid(userDetailsForm, 'employeeId')"
                      placeholder="Enter your employee ID"
                    />
                    <span class="error-message" *ngIf="isFieldInvalid(userDetailsForm, 'employeeId')">
                      {{ getErrorMessage(userDetailsForm, 'employeeId') }}
                    </span>
                  </div>
                </div>

                <div class="form-actions">
                  <button type="button" class="btn btn-secondary" (click)="onCancel()">
                    Cancel
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-primary" 
                    (click)="userDetailsForm.valid && (activeStep = 1)"
                    [disabled]="userDetailsForm.invalid"
                  >
                    Next
                    <svg class="btn-icon-right" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </form>
            </div>

            <!-- Step 2: Provider Entity Details -->
            <div class="step-panel" *ngIf="activeStep === 1">
              <form [formGroup]="entityDetailsForm" class="step-form">
                <div class="form-grid">

                  <!-- Entity Name -->
                  <div class="form-field full-width">
                    <label for="entityName" class="form-label">
                      Name of the Organisation <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="entityName"
                      formControlName="entityName"
                      class="form-input"
                      [class.input-error]="isFieldInvalid(entityDetailsForm, 'entityName')"
                      placeholder="Enter Organisation name"
                    />
                    <span class="error-message" *ngIf="isFieldInvalid(entityDetailsForm, 'entityName')">
                      {{ getErrorMessage(entityDetailsForm, 'entityName') }}
                    </span>
                    <div class="name-exists-message" *ngIf="nameExists !== null && !isFieldInvalid(entityDetailsForm, 'entityName')">
                      <span *ngIf="checkingName" class="name-checking">Checking...</span>
                      <span *ngIf="!checkingName && nameExists" class="name-exists">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <circle cx="12" cy="12" r="10" stroke-width="2"/>
                          <line x1="15" y1="9" x2="9" y2="15" stroke-width="2" stroke-linecap="round"/>
                          <line x1="9" y1="9" x2="15" y2="15" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Name already exists
                      </span>
                      <span *ngIf="!checkingName && !nameExists" class="name-available">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="22 4 12 14.01 9 11.01" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Name is available
                      </span>
                    </div>
                  </div>


                  <!-- Entity Type -->
                  <div class="form-field">
                    <label for="entityType" class="form-label">
                      Entity Type <span class="required">*</span>
                    </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="isFieldInvalid(entityDetailsForm, 'entityType')"
                        [class.open]="isEntityTypeDropdownOpen"
                        (click)="toggleEntityTypeDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!entityDetailsForm.get('entityType')?.value" class="placeholder">Select entity type</span>
                          <span *ngIf="entityDetailsForm.get('entityType')?.value" class="selected-value">
                            {{ getSelectedEntityTypeLabel() }}
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isEntityTypeDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" *ngIf="isEntityTypeDropdownOpen">
                        <div
                          *ngFor="let option of entityTypes"
                          class="dropdown-option"
                          [class.selected]="isEntityTypeSelected(option.value)"
                          (click)="selectEntityType(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isEntityTypeSelected(option.value)">
                              <svg *ngIf="isEntityTypeSelected(option.value)" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <span class="error-message" *ngIf="isFieldInvalid(entityDetailsForm, 'entityType')">
                      {{ getErrorMessage(entityDetailsForm, 'entityType') }}
                    </span>
                  </div>

                  <!-- Entity Sector -->
                  <div class="form-field">
                    <label for="entitySector" class="form-label">
                      Entity Sector <span class="required">*</span>
                    </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="isFieldInvalid(entityDetailsForm, 'entitySector')"
                        [class.open]="isEntitySectorDropdownOpen"
                        (click)="toggleEntitySectorDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!entityDetailsForm.get('entitySector')?.value" class="placeholder">Select sector</span>
                          <span *ngIf="entityDetailsForm.get('entitySector')?.value" class="selected-value">
                            {{ getSelectedEntitySectorLabel() }}
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isEntitySectorDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" *ngIf="isEntitySectorDropdownOpen">
                        <div
                          *ngFor="let option of entitySectors"
                          class="dropdown-option"
                          [class.selected]="isEntitySectorSelected(option.value)"
                          (click)="selectEntitySector(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isEntitySectorSelected(option.value)">
                              <svg *ngIf="isEntitySectorSelected(option.value)" width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <span class="error-message" *ngIf="isFieldInvalid(entityDetailsForm, 'entitySector')">
                      {{ getErrorMessage(entityDetailsForm, 'entitySector') }}
                    </span>
                  </div>

                

                  <!-- Website URL -->
                  <div class="form-field">
                    <label for="websiteUrl" class="form-label">
                      Website URL <span class="required">*</span>
                    </label>
                    <input
                      type="url"
                      id="websiteUrl"
                      formControlName="websiteUrl"
                      class="form-input"
                      [class.input-error]="isFieldInvalid(entityDetailsForm, 'websiteUrl')"
                      placeholder="https://example.com"
                    />
                    <span class="error-message" *ngIf="isFieldInvalid(entityDetailsForm, 'websiteUrl')">
                      {{ getErrorMessage(entityDetailsForm, 'websiteUrl') }}
                    </span>
                  </div>

                  <!-- Address -->
                  <div class="form-field">
                    <label for="address" class="form-label">
                      Address <span class="required">*</span>
                    </label>
                    <textarea
                      id="address"
                      formControlName="address"
                      class="form-input form-textarea"
                      [class.input-error]="isFieldInvalid(entityDetailsForm, 'address')"
                      placeholder="Enter complete address"
                      rows="3"
                    ></textarea>
                    <span class="error-message" *ngIf="isFieldInvalid(entityDetailsForm, 'address')">
                      {{ getErrorMessage(entityDetailsForm, 'address') }}
                    </span>
                  </div>
                </div>

                <div class="form-actions">
                  <button type="button" class="btn btn-secondary" (click)="activeStep = 0">
                    <svg class="btn-icon-left" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M19 12H5M12 19l-7-7 7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Back
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-primary" 
                    (click)="entityDetailsForm.valid && (activeStep = 2)"
                    [disabled]="entityDetailsForm.invalid"
                  >
                    Next
                    <svg class="btn-icon-right" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </div>
              </form>
            </div>

            <!-- Step 3: Document Upload -->
            <div class="step-panel" *ngIf="activeStep === 2">
              <form [formGroup]="documentsForm" class="step-form">
                <div class="documents-grid">
                  <!-- Firm Incorporation Certificate -->
                  <div class="document-field">
                    <label class="document-label">
                      Firm Incorporation Certificate <span class="required">*</span>
                    </label>
                    <div class="file-upload-wrapper">
                      <div class="file-upload-area">
                        <input
                          type="file"
                          id="incorporation"
                          accept=".pdf"
                          (change)="onFileSelect($event, 'incorporation')"
                          class="file-input"
                        />
                        <label for="incorporation" class="file-upload-label" *ngIf="!getFileName('incorporation')">
                          <svg class="upload-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="upload-text">Click to upload</span>
                          <span class="upload-hint">PDF (Max 5MB)</span>
                        </label>
                        <div class="file-selected" *ngIf="getFileName('incorporation')">
                          <!-- Default File Icon - Show when upload is not successful or still loading -->
                          <svg *ngIf="!uploadStatus['incorporation'].success" class="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <polyline points="13 2 13 9 20 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="file-name">{{ getFileName('incorporation') }}</span>
                          <button type="button" class="file-remove" (click)="removeFile('incorporation')">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <line x1="18" y1="6" x2="6" y2="18" stroke-width="2" stroke-linecap="round"/>
                              <line x1="6" y1="6" x2="18" y2="18" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <!-- Circular PDF Preview Icon - Outside the green container -->
                      <button 
                        *ngIf="getFileName('incorporation') && uploadStatus['incorporation'].success" 
                        type="button" 
                        class="pdf-preview-icon" 
                        [class.loading]="uploadStatus['incorporation'].loadingPreview"
                        [disabled]="uploadStatus['incorporation'].loadingPreview"
                        (click)="openPdfPreview('incorporation')"
                        title="Preview PDF"
                      >
                        <svg *ngIf="!uploadStatus['incorporation'].loadingPreview" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="uploadStatus['incorporation'].loadingPreview" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                          </circle>
                        </svg>
                      </button>
                    </div>
                    <span class="error-message" *ngIf="isFieldInvalid(documentsForm, 'incorporation')">
                      {{ getErrorMessage(documentsForm, 'incorporation') }}
                    </span>
                  </div>

                  <!-- PAN Card -->
                  <div class="document-field">
                    <label class="document-label">
                      PAN Card <span class="required">*</span>
                    </label>
                    <div class="file-upload-wrapper">
                      <div class="file-upload-area">
                        <input
                          type="file"
                          id="panCard"
                          accept=".pdf"
                          (change)="onFileSelect($event, 'panCard')"
                          class="file-input"
                        />
                        <label for="panCard" class="file-upload-label" *ngIf="!getFileName('panCard')">
                          <svg class="upload-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="upload-text">Click to upload</span>
                          <span class="upload-hint">PDF (Max 5MB)</span>
                        </label>
                        <div class="file-selected" *ngIf="getFileName('panCard')">
                          <!-- Default File Icon - Show when upload is not successful or still loading -->
                          <svg *ngIf="!uploadStatus['panCard'].success" class="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <polyline points="13 2 13 9 20 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="file-name">{{ getFileName('panCard') }}</span>
                          <button type="button" class="file-remove" (click)="removeFile('panCard')">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <line x1="18" y1="6" x2="6" y2="18" stroke-width="2" stroke-linecap="round"/>
                              <line x1="6" y1="6" x2="18" y2="18" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <!-- Circular PDF Preview Icon - Outside the green container -->
                      <button 
                        *ngIf="getFileName('panCard') && uploadStatus['panCard'].success" 
                        type="button" 
                        class="pdf-preview-icon" 
                        [class.loading]="uploadStatus['panCard'].loadingPreview"
                        [disabled]="uploadStatus['panCard'].loadingPreview"
                        (click)="openPdfPreview('panCard')"
                        title="Preview PDF"
                      >
                        <svg *ngIf="!uploadStatus['panCard'].loadingPreview" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="uploadStatus['panCard'].loadingPreview" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                          </circle>
                        </svg>
                      </button>
                    </div>
                    <span class="error-message" *ngIf="isFieldInvalid(documentsForm, 'panCard')">
                      {{ getErrorMessage(documentsForm, 'panCard') }}
                    </span>
                  </div>

                  <!-- Letter of Authorization -->
                  <div class="document-field">
                    <label class="document-label">
                      Letter of Authorization <span class="required">*</span>
                    </label>
                    <div class="file-upload-wrapper">
                      <div class="file-upload-area">
                        <input
                          type="file"
                          id="authorization"
                          accept=".pdf"
                          (change)="onFileSelect($event, 'authorization')"
                          class="file-input"
                        />
                        <label for="authorization" class="file-upload-label" *ngIf="!getFileName('authorization')">
                          <svg class="upload-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="upload-text">Click to upload</span>
                          <span class="upload-hint">PDF (Max 5MB)</span>
                        </label>
                        <div class="file-selected" *ngIf="getFileName('authorization')">
                          <!-- Default File Icon - Show when upload is not successful or still loading -->
                          <svg *ngIf="!uploadStatus['authorization'].success" class="file-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <polyline points="13 2 13 9 20 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="file-name">{{ getFileName('authorization') }}</span>
                          <button type="button" class="file-remove" (click)="removeFile('authorization')">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <line x1="18" y1="6" x2="6" y2="18" stroke-width="2" stroke-linecap="round"/>
                              <line x1="6" y1="6" x2="18" y2="18" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <!-- Circular PDF Preview Icon - Outside the green container -->
                      <button 
                        *ngIf="getFileName('authorization') && uploadStatus['authorization'].success" 
                        type="button" 
                        class="pdf-preview-icon" 
                        [class.loading]="uploadStatus['authorization'].loadingPreview"
                        [disabled]="uploadStatus['authorization'].loadingPreview"
                        (click)="openPdfPreview('authorization')"
                        title="Preview PDF"
                      >
                        <svg *ngIf="!uploadStatus['authorization'].loadingPreview" class="pdf-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="13" x2="8" y2="13" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <line x1="16" y1="17" x2="8" y2="17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="10 9 9 9 8 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="uploadStatus['authorization'].loadingPreview" class="spinner" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <circle cx="12" cy="12" r="10" stroke-width="2" stroke-linecap="round" stroke-dasharray="31.416" stroke-dashoffset="31.416">
                            <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/>
                            <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/>
                          </circle>
                        </svg>
                      </button>
                    </div>
                    <span class="error-message" *ngIf="isFieldInvalid(documentsForm, 'authorization')">
                      {{ getErrorMessage(documentsForm, 'authorization') }}
                    </span>
                  </div>
                </div>

                <div class="form-actions">
                  <button type="button" class="btn btn-secondary" (click)="activeStep = 1">
                    <svg class="btn-icon-left" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M19 12H5M12 19l-7-7 7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Back
                  </button>
                  <button 
                    type="button" 
                    class="btn btn-primary btn-submit" 
                    (click)="onSubmit()"
                    [disabled]="documentsForm.invalid"
                  >
                    <svg class="btn-icon-left" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <polyline points="20 6 9 17 4 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Submit Application
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Success Modal -->
<app-confirmation-dialog
  [(visible)]="showSuccessModal"
  type="success"
  title="Request Sent Successfully"
  message="Your organisation creation request has been submitted. Your request is awaiting approval from the Administrator."
  confirmLabel="GOT IT, THANKS!"
  [showCancelButton]="false"
  themeColor="green"
  width="540px"
  nextStepsTitle="What happens next:"
  nextStepsMessage="You'll receive a notification once the Administrator reviews and responds to your request."
  (onConfirm)="onSuccessModalConfirm()"
  (onClose)="onSuccessModalClose()"
></app-confirmation-dialog>

<!-- PDF Preview Modal -->
<app-modal
  [(visible)]="showPdfPreviewModal"
  [header]="currentPdfTitle"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closePdfPreview()"
>
  <div class="pdf-preview-container" *ngIf="currentPdfUrl">
    <!-- Loading state -->
    <div *ngIf="pdfLoading" class="pdf-loading">
      <div class="loading-spinner"></div>
      <p>Loading PDF...</p>
    </div>
    
    <!-- PDF Viewer -->
    <pdf-viewer
      *ngIf="!pdfLoading && currentPdfUrl"
      [src]="currentPdfUrl"
      [render-text]="true"
      [original-size]="false"
      [show-all]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="true"
      style="width: 100%; height: 100%;"
    ></pdf-viewer>
  </div>
</app-modal>
